import styled, { css } from "styled-components";
import { Error, Label, FieldWrapper } from "components/shared/form";
import colours from "assets/colours";
import queries from "utils/responsivenessHelper";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  ${Error} {
    margin: 8px auto;
    white-space: nowrap;
  }
`;

const CheckboxFieldWrapper = styled(FieldWrapper)`
  ${({ reverse, inline }) =>
    reverse
      ? css`
          flex-direction: ${inline ? "row-reverse" : "column-reverse"};
        `
      : css`
          flex-direction: ${inline ? "row" : "column"};
        `}
`;

const CheckboxLabel = styled(Label)`
  margin-right: 10px;
  white-space: normal;
  cursor: pointer;
  ${queries.both({ fontSize: "1rem" })}
`;

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  position: relative;
`;

const Icon = styled.svg`
  fill: none;
  stroke: ${colours.white};
  stroke-width: 4px;
  width: 75%;
`;

const HiddenCheckbox = styled.input.attrs({
  type: "checkbox",
})`
  opacity: 0;
  position: absolute;
  cursor: pointer;
`;

const StyledCheckbox = styled.div`
  display: flex;
  width: 1.25em;
  height: 1.25em;
  transition: all 150ms;
  border-radius: 100%;
  box-sizing: border-box;
  background: ${colours.white};
  border: 2px solid ${colours.lightBlue};
  cursor: pointer;
  justify-content: center;
  align-items: center;

  ${({ checked }) =>
    checked &&
    css`
      background: ${colours.lightBlue};
      box-shadow: 0px 3px 10px rgba(80, 202, 241, 0.5);
    `}

  ${Icon} {
    visibility: ${(props) => (props.checked ? "visible" : "hidden")};
  }
`;

export {
  Container,
  CheckboxFieldWrapper,
  CheckboxContainer,
  Icon,
  StyledCheckbox,
  HiddenCheckbox,
  CheckboxLabel,
};
